<template>
  <div class="dialog-bg" v-if="show" @click="cancelShow" @mousemove="modalMove" @mouseup="cancelMove">
    <div class="dialog-container" @click.stop>
      <div class="dialog-title" @mousedown="setStartingPoint">
        <div class="title">{{title}}</div>
        <img src="../../assets/img/closeWhite.png" alt="" @click="cancelShow" class="my_close">
      </div>
      <div class="dialog-main">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dialog_tip",
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    title: {
      type: String,
      default: '温馨提示'
    }
  },
  data(){
    return{
      x: 0,             // x 轴坐标
      y: 0,             // y 轴坐标
      node: null,       // 弹窗元素
      isCanMove: false  // 是否能够拖拽
    }
  },
  methods: {
    cancelShow(){
      this.$emit('cancel', false)
    },
    setStartingPoint(e) {
      this.node = document.querySelector('.dialog-container')
      this.x = e.clientX - this.node.offsetLeft
      this.y = e.clientY - this.node.offsetTop
      this.isCanMove = true
    },
    modalMove(e) {
      if (this.isCanMove) {
        this.node.style.left = e.clientX - this.x + 'px'
        this.node.style.top = e.clientY - this.y + 'px'
      }
    },
    cancelMove() {
      this.isCanMove = false
    }
  }
}
</script>

<style scoped>
.dialog-bg{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.dialog-container{
  user-select: none;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
  box-shadow: 2px 4px 15px 5px #bfbfbf;
}

.dialog-title{
  padding: 10px 20px;
  display: flex;
  color: white;
  background-color: #00a0c7;
  justify-content: space-between;
  border-bottom: 1px solid #e8e8e8;
}

.title{
  font-size: 14px;
  font-weight: bold;
  margin-right: 10px;
}

.dialog-main{
  padding: 5px 10px;
}

.my_close{
  width: 20px;
  height: 20px;
  margin: -5px -15px 0 0;
  cursor: pointer;
}
</style>
